import Highway from '@dogstudio/highway'

import ScrollTrigger from 'gsap/ScrollTrigger'

import Animations from './Animations'
import Timeline from './Timeline'
import Technology from './Technology'
import Team from './Team'

class FrontpageRenderer extends Highway.Renderer {
  onEnterCompleted() {
    new Animations()
    new Timeline()
    new Technology()
    new Team()
  }

  onLeaveCompleted() {
    ScrollTrigger.getAll().forEach((t) => t.kill())
  }
}

export default FrontpageRenderer
